(function(){
  if(window.__smHeaderCartSyncV1)return;
  window.__smHeaderCartSyncV1=true;
  var timer=null;
  function paint(n){
    document.querySelectorAll('.sm-logo-header__cart b,.smx-cart b,.sm9-cart-count,[data-sm-cart-items]').forEach(function(el){el.textContent=n});
  }
  function sync(){
    clearTimeout(timer);
    timer=setTimeout(function(){
      fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
        .then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
        .then(function(c){paint(c.item_count||0)})
        .catch(function(){});
    },80);
  }
  ['cart:updated','cart:refresh','sm:cart:add'].forEach(function(name){document.addEventListener(name,sync)});
  window.addEventListener('pageshow',sync);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync,{once:true});else sync();
})();